/* eslint-disable react/state-in-constructor */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable @typescript-eslint/consistent-type-definitions */
import { Component, ReactNode, ErrorInfo } from 'react';

interface ErrorBoundaryState {
	hasError: boolean;
}

interface ErrorBoundaryProps {
	readonly children: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		// Opción de mandar el error a un log de frontend errors
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): ErrorBoundaryState {
		console.log('ErrorBoundary getDerivedStateFromError:', error);
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Error caught in ErrorBoundary:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div>
					{/* Crear página de gestión de errores */}
					<p>Algo ha salido mal.</p>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
